import { render, staticRenderFns } from "./CardWrapper.vue?vue&type=template&id=416097f6&scoped=true&"
import script from "./CardWrapper.vue?vue&type=script&lang=js&"
export * from "./CardWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CardWrapper.vue?vue&type=style&index=0&id=416097f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416097f6",
  null
  
)

export default component.exports